var map = {
	"./common/Calendar.svg": 25284,
	"./common/green-thumbs-up.svg": 47987,
	"./common/red-thumbs-down.svg": 66836,
	"./dashboard/all-logs.svg": 68292,
	"./dashboard/calendar-icon.svg": 42957,
	"./dashboard/calendar.svg": 1193,
	"./dashboard/colleagues.svg": 22579,
	"./dashboard/estimated_time-icon.svg": 24849,
	"./dashboard/hurry-icon.svg": 47555,
	"./dashboard/logs.svg": 23366,
	"./dashboard/scorecard-icon.svg": 65229,
	"./dashboard/team-backlog.svg": 92926,
	"./dashboard/team-log.svg": 45765,
	"./dashboard/teams.svg": 3203,
	"./forecastify_logo_text_blue.svg": 57166,
	"./forecastify_logo_text_white.svg": 87133,
	"./integrations/jira_logo.svg": 33358,
	"./logging/dark_lost-folder.svg": 98608,
	"./logging/lost-folder.svg": 26353,
	"./login_background.jpg": 26953,
	"./login_logo.svg": 1699,
	"./loginet_logo_nav_color.svg": 4836,
	"./logo.svg": 1125,
	"./logo_closed.svg": 93560,
	"./onboarding/Emoji.png": 55839,
	"./onboarding/background-main.png": 6603,
	"./onboarding/code.png": 88542,
	"./onboarding/design.png": 83367,
	"./onboarding/external_issue_tracker_sync_start.jpg": 96850,
	"./onboarding/external_issue_tracker_sync_succes_tick.png": 37371,
	"./onboarding/fourthOption.png": 9034,
	"./onboarding/jira_api_token.png": 11950,
	"./onboarding/polygon.svg": 23148,
	"./onboarding/thirdOption.png": 64193,
	"./onboarding/youtrack_api_token.png": 10416,
	"./payments/bigfish-logo-wide-colored-dark-font.png": 28683,
	"./payments/otpsimplepay.png": 66210,
	"./project/accounting.svg": 81261,
	"./project/bookmark.svg": 60098,
	"./project/calendar.svg": 98496,
	"./project/clock-lines.svg": 84590,
	"./project/delivery-time.svg": 32784,
	"./project/forecast-banner.svg": 32052,
	"./project/handshake.svg": 69389,
	"./project/lock-solid.svg": 57969,
	"./project/money-bag-checked.svg": 76923,
	"./project/money-bag-colorable.svg": 59129,
	"./project/money-bag-colorless.svg": 478,
	"./project/money-bag-pounds.svg": 15161,
	"./project/money.svg": 80714,
	"./project/open-check.svg": 54809,
	"./project/project-check.svg": 55442,
	"./project/project-load.gif": 39406,
	"./project/project-load.svg": 52370,
	"./project/project-question.svg": 77954,
	"./project/red-x-icon.svg": 4418,
	"./project/time-management.svg": 30975,
	"./schedule/beach.svg": 72727,
	"./schedule/no-workschedule.svg": 96668,
	"./shop-entity-default.png": 93263,
	"./shop-entity-default.webp": 15724,
	"./timesheet/beach.svg": 34092,
	"./timesheet/beachVacation.svg": 57353,
	"./timesheet/guru.svg": 5864,
	"./timesheet/guruVacation.svg": 95109,
	"./vacation_logo.png": 32166,
	"./vacation_mono_black.svg": 44873,
	"./vacation_mono_white.svg": 38975,
	"./vacation_mono_white_closed.svg": 62582
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;